// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__39WY9","empty":"ModalGraph_empty__17YJo"};